import { Flex } from "@chakra-ui/react"
import PropTypes from "prop-types"
import styled from "styled-components"

import AttributeMeta from "../AttributeMeta"
import AttributeName from "../AttributeName"
import Spacer from "../Spacer"
import SortingArrow from "./SortingArrow"

import theme from "../../../../../theme/emotion-theme"
import { attributeIDs } from "../../common/constants"

const TableHeadCell = styled.div`
  display: flex;
  height: ${({ theme }) => theme.sizes.gapLarge * 4}px;
  padding: ${({ theme }) => theme.sizes.gapMedium - 2}px ${({ theme }) => theme.sizes.gapLarge}px;
  align-items: flex-start;
  background-color: ${({ theme }) => theme.colors.baseWhite};
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray[300]};
  border-right: 1px solid ${({ theme }) => theme.colors.gray[300]};
  overflow: hidden;

  &.th--article-code:not(.th--article-code--single-attribute) {
    flex: none !important;
  }

  &.th--article-code {
    position: sticky !important; //so that react-table doesn't override with inline styles
    left: 0;
    justify-content: center;
    overflow: visible;
    z-index: 1;
  }

  &.th--sortable {
    :hover {
      @media (hover: hover) and (pointer: fine) {
        background-color: ${({ theme }) => theme.colors.gray[200]};
      }
    }
    :active {
      background-color: ${({ theme }) => theme.colors.gray[900]};
      color: ${({ theme }) => theme.colors.baseWhite};
      & > svg {
        color: ${({ theme }) => theme.colors.baseWhite};
      }
    }
    transition: background-color 100ms linear;
  }

  &.th--sortable--right {
    padding-right: ${({ theme }) => theme.sizes.gapMedium}px;
  }

  &.th--sortable--left {
    padding-left: ${({ theme }) => theme.sizes.gapMedium}px;
  }

  &.th--right-aligned {
    justify-content: flex-end;
  }

  & > svg {
    align-self: flex-start;
  }
`

const HeaderCell = ({ column, isArticleCodeCell, isSortable, isSingleAttribute }) => {
  const isUnitOrPrice = !!column.unit || column.id === attributeIDs.NET_PRICE || column.id === attributeIDs.GROSS_PRICE

  return (
    <TableHeadCell
      {...column.getHeaderProps(column.getSortByToggleProps())}
      className={`${isArticleCodeCell && "th--article-code"}
                     ${isSortable && `th--sortable th--sortable--${isUnitOrPrice ? "left" : "right"}`}
                     ${isUnitOrPrice && "th--right-aligned"}
                     ${isSingleAttribute && "th--article-code--single-attribute"}`}
    >
      {isUnitOrPrice ? (
        <>
          {isSortable && (
            <>
              <SortingArrow isSorted={column.isSorted} isSortedDesc={column.isSortedDesc} />
              <Spacer axis="horizontal" size={theme.sizes.gapMedium} />
            </>
          )}
          <Flex flexDirection="column" alignItems="flex-end">
            <AttributeName text={column.render("Header")} />
            <AttributeMeta text={column.unit} />
          </Flex>
        </>
      ) : (
        <>
          <AttributeName text={column.render("Header")} />
          {isSortable && (
            <>
              <Spacer axis="horizontal" size={theme.sizes.gapMedium} />
              <SortingArrow isSorted={column.isSorted} isSortedDesc={column.isSortedDesc} />
            </>
          )}
        </>
      )}
    </TableHeadCell>
  )
}

export default HeaderCell

HeaderCell.propTypes = {
  column: PropTypes.object,
  isArticleCodeCell: PropTypes.bool,
  isSortable: PropTypes.bool,
  isSingleAttribute: PropTypes.bool,
}
